'use client'

import { Box, Button, CircularProgress, Skeleton, Stack, Typography } from '@mui/material'
import { gql, useLazyQuery } from '@apollo/client'
import { useEffect, useMemo } from 'react'
import { darkRoyalBlue, GetPaymentMethod, Logger, Module, white } from '@wolfdanepug/common-react'
import { paymentBrandIcons } from '../../constants'
import { NavLink } from 'react-router'

export const PaymentMethodModule = ({ subscription, canModify = true }: any) => {
	const [fetchPaymentMethod, { data, error, called }] = useLazyQuery(gql(GetPaymentMethod))

	useEffect(() => {
		!called &&
			subscription &&
			fetchPaymentMethod({
				variables: {
					id: subscription?.paymentMethod?.id
				}
			})
	}, [subscription, called, fetchPaymentMethod])

	useEffect(() => {
		error && Logger.error(error)
	}, [error])

	const paymentMethod = data?.getPaymentMethod
	const last4 = paymentMethod?.reference?.card?.last4

	const paymentMethodIcon = useMemo(() => {
		const brand = paymentMethod?.reference?.card?.brand
		if (!brand) return null
		return paymentBrandIcons[brand]
	}, [paymentMethod?.reference?.card?.brand])

	Logger.log('[subscription] page', paymentMethod)

	return (
		<Module
			title="Payment Method"
			color={darkRoyalBlue}
			showOverlay
			sx={{
				content: {
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					gap: 3
				},
				title: {
					fontSize: '22px',
					fontWeight: 500,
					color: white
				},
				text: {
					color: white,
					fontSize: '14px'
				},
				action: {
					color: white
				}
			}}
		>
			<Stack flexDirection="column" justifyContent="space-between" flex={1}>
				<Box display="flex" flex={1} sx={{ alignItems: 'flex-start' }}>
					{last4 ? (
						<Typography variant="body2" color={white}>
							**** **** **** {paymentMethod?.reference?.card?.last4}
						</Typography>
					) : (
						<Skeleton
							variant="text"
							width="100%"
							height={30}
							sx={{ bgcolor: 'rgba(255,255,255,.5)' }}
						/>
					)}
				</Box>
				<Stack direction="row" justifyContent="space-between" alignItems="center">
					<Box sx={{ color: white }}>
						{paymentMethodIcon ? (
							<Box component={'img'} src={paymentMethodIcon} sx={{ height: 50 }} />
						) : (
							<Box
								sx={{
									display: 'flex',
									alignItems: 'center',
									height: 50,
									width: 50,
									justifyContent: 'center'
								}}
							>
								<CircularProgress size="20px" />
							</Box>
						)}
					</Box>
					{canModify && (
						<Button
							variant="contained"
							size="small"
							LinkComponent={NavLink}
							href="/dashboard/settings/payment-methods"
							sx={{
								backgroundColor: 'rgba(255,255,255,.3)',
								color: white,
								alignSelf: 'center',
								'&:hover': {
									backgroundColor: 'rgba(255,255,255,.5)'
								}
							}}
						>
							Update
						</Button>
					)}
				</Stack>
			</Stack>
		</Module>
	)
}
